/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Col_ReasonInputs */

const cs_import_match_col_reason = /** @type {(inputs: Import_Match_Col_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda`)
};

const en_import_match_col_reason = /** @type {(inputs: Import_Match_Col_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

/**
* | output |
* | --- |
* | "Match" |
*
* @param {Import_Match_Col_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_col_reason = /** @type {((inputs?: Import_Match_Col_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Col_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_col_reason(inputs)
	return cs_import_match_col_reason(inputs)
});